import { createRelationshipTypeColDef } from '../../../../../components/shared-columns/relationship-type';
import type { InvestorCoverageRow } from '../InvestorCoverageGrid.model';
import { isInvestorCoverageColumnEditable } from './columns.model';

export const relationshipTypeColDef = createRelationshipTypeColDef<InvestorCoverageRow>({
  editable: isInvestorCoverageColumnEditable,
});
